export default __webpack_public_path__ + "static/media/3 icon (1).428bd28a.jpg";